type SelectableChipOption = {
  value: string;
  label: string;
};

type SelectableChipsProps = {
  label: string;
  options: SelectableChipOption[];
  value: string[];
  onChange: (value: string[]) => void;
  hint?: string;
};

export function chipToggleClassName(selected: boolean, className = ''): string {
  return `inline-flex items-center min-h-[44px] px-4 rounded-full text-sm font-semibold transition-colors duration-150 focus-ring ${
    selected ? 'bg-primary text-white' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'
  } ${className}`;
}

export default function SelectableChips({
  label,
  options,
  value,
  onChange,
  hint,
}: SelectableChipsProps) {
  return (
    <fieldset>
      <legend className="block text-sm font-medium text-gray-700 mb-2">{label}</legend>
      {hint && <p className="text-sm text-gray-500 mb-3">{hint}</p>}
      <div className="flex flex-wrap gap-2">
        {options.map((option) => {
          const selected = value.includes(option.value);
          return (
            <button
              key={option.value}
              type="button"
              aria-pressed={selected}
              onClick={() =>
                onChange(
                  selected ? value.filter((item) => item !== option.value) : [...value, option.value]
                )
              }
              className={chipToggleClassName(selected)}
            >
              {option.label}
            </button>
          );
        })}
      </div>
    </fieldset>
  );
}
